import roles from '../customers/roles/roles';
import taskTypes from '../tasks/taskTypes';
import imageType from './image_type';
import priorities, { prioritiesMap } from './priorities';
import difficultyTypes from './difficultyTypes';
import hcContentTypes from './hcContentTypes';



export const pricesRoles = { ...roles };

Object.keys(roles).forEach((key) => {
  pricesRoles[key] = {
    key: `price-${key}`,
    title: `Price for ${roles[key].title}`,
    role: roles[key],
    isRequired: true,
    type: 'number',
    muted: `Please enter price for ${roles[key].title.toLowerCase()}`,
  };
});

/**
 * Types of fields in the project
 *
 * @type {{date: number, input: number, shutterstock: number, optionsSearch: number, options: number, textarea: number, inputSelect: number, switch: number}}
 */
export const typesFields = {
  input: 1,
  options: 2,
  date: 3,
  textarea: 4,
  inputSelect: 5,
  shutterstock: 6,
  switch: 7,
  optionsSearch: 8,
  htmlEditor: 9,
};

/**
 * Global project types
 *
 * @type {{COLORING: string}}
 */
export const globalTypesProject = {
  COLORING: 'coloring',
};

export const coloringProjectTypes = {
  COLORING: 'coloring',
  COLORING_ANY: 'coloring-any',
  COLORING_ARTIST: 'coloring-artist',
};

export const projectStatuses = {
  reopened: 'reopened',
  draft: 'draft',
  waiting: 'waiting',
  process: 'process',
  finished: 'finished',
  archived: 'archived',
};

/**
 * Types of projects and config fields in it for building project creation
 *
 * @type {[{generalSettings: [{typeFields: number, isRequired: boolean, title: string, value: string, key: string}, {typeFields: number, min: string, pattern: RegExp, step: string, placeholder: string, type: string, title: string, key: string}, {typeFields: number, isRequired: boolean, subgroup: string, options: string[], addedFields: [{typeFields: number, isRequired: boolean, min: string, pattern: RegExp, step: string, placeholder: string, title: string, type: string, value: string, key: string}, {typeFields: number, title: string, value: string, key: string}, {typeFields: number, isRequired: boolean, title: string, value: string, key: string}, {typeFields: number, title: string, value: string, key: string}, {typeFields: number, title: string, value: string, key: string}, null, null, null, null, null, null, null, null], title: string, key: string}], title: string, type: string, projectSettings: [{typeFields: number, title: string, key: string}, {typeFields: number, addedFields: [{typeFields: number, isRequired: boolean, subgroup: string, keys: string[], title: string, value: string, translate: string, key: string}], title: string, key: string}, {typeFields: number, isRequired: boolean, subgroup: string, options: string[], title: string, key: string}], key: string}, {generalSettings: [{typeFields: number, isRequired: boolean, title: string, value: string, key: string}, {typeFields: number, min: string, pattern: RegExp, step: string, placeholder: string, type: string, title: string, key: string}, {typeFields: number, isRequired: boolean, subgroup: string, options: string[], addedFields: [{typeFields: number, isRequired: boolean, min: string, pattern: RegExp, step: string, placeholder: string, title: string, type: string, value: string, key: string}, {typeFields: number, title: string, value: string, key: string}, {typeFields: number, isRequired: boolean, title: string, value: string, key: string}, {typeFields: number, title: string, value: string, key: string}, {typeFields: number, title: string, value: string, key: string}, null, null, null, null, null, null, null, null], title: string, key: string}], title: string, type: string, projectSettings: [{typeFields: number, title: string, key: string}, {typeFields: number, title: string, key: string}, {typeFields: number, isRequired: boolean, subgroup: string, options: string[], title: string, key: string}], key: string}]}
 */
export const projectTypes = [ {
  key: 'coloring',
  title: 'Image for coloring (contour)',
  type: globalTypesProject.COLORING,
  generalSettings: [
    {
      key: 'title',
      title: 'Title',
      typeFields: typesFields.input,
      pattern: /[^а-яА-Я]+/,
      isRequired: true,
      altTitle: 'В названии проекта можно использовать только латиницу',
    },
    {
      key: 'category_id',
      title: 'Category',
      typeFields: typesFields.optionsSearch,
      isRequired: false,
      translate: 'TAGS.CATEGORY',
    },
    {
      key: 'categories',
      title: 'Categories',
      typeFields: typesFields.inputSelect,
      isRequired: false,
      translate: 'TAGS.CATEGORIES',
    },
    {
      key: 'hc_release_date',
      min: new Date(),
      title: 'Release date in Happy Color',
      typeFields: typesFields.date,
    },
    {
      key: 'deadline',
      min: new Date(),
      title: 'Deadline',
      typeFields: typesFields.date,
      isRequired: true,
    },
    {
      key: 'hc_content_type',
      title: 'Content type in Happy Color',
      typeFields: typesFields.options,
      options: hcContentTypes,
    },
    {
      key: 'priority',
      title: 'Priority',
      typeFields: typesFields.options,
      options: priorities.map((priority) => prioritiesMap[priority]),
      isRequired: true,
    },
    {
      key: 'difficult',
      title: 'Difficulty',
      typeFields: typesFields.options,
      options: difficultyTypes,
    },
    {
      key: 'tags',
      title: 'Tags',
      typeFields: typesFields.inputSelect,
    },
    {
      key: 'contour_complexity_level',
      title: 'Contour complexity level',
      typeFields: typesFields.options,
      options: [ 1, 2, 3, 4 ],
      isRequired: true,
      addedFields: [
        {
          value: '4',
          type: 'number',
          step: '1',
          pattern: /^\d+$/,
          placeholder: 'Укажите число больше 0',
          min: '1',
          key: 'artist_price',
          title: 'Artist Price',
          typeFields: typesFields.input,
          isRequired: true,
        },
      ],
    },
    {
      key: 'color_complexity_level',
      title: 'Color complexity level',
      typeFields: typesFields.options,
      options: [ '1', '2', '3', '4' ],
      isRequired: true,
      addedFields: [
        {
          value: '4',
          type: 'number',
          step: '1',
          pattern: /^\d+$/,
          placeholder: 'Укажите число больше 0',
          min: '1',
          key: 'designer_price',
          title: 'Designer Price',
          typeFields: typesFields.input,
          isRequired: true,
        },
      ],
    },
  ],
  projectSettings: [
    {
      key: 'type',
      title: 'Image category',
      typeFields: typesFields.options,
      options: imageType,
      isRequired: true,
      subgroup: 'options',
    },
    {
      key: 'status',
      title: 'Status',
      typeFields: typesFields.switch,
    },
    {
      key: 'comment',
      title: 'Comment',
      typeFields: typesFields.htmlEditor,
    },
  ],
}, {
  key: 'coloring-artist',
  title: 'Image for coloring (Artist)',
  type: globalTypesProject.COLORING,
  generalSettings: [
    {
      key: 'title',
      title: 'Title',
      pattern: /[^а-яА-Я]+/,
      typeFields: typesFields.input,
      isRequired: true,
      altTitle: 'В названии проекта можно использовать только латиницу',
    },
    {
      type: 'number',
      step: '1',
      pattern: /^\d+$/,
      placeholder: 'Укажите число больше 0',
      min: '1',
      key: 'difficult',
      title: 'Difficulty',
      typeFields: typesFields.input,
    },
    {
      key: 'tags',
      title: 'Tags',
      typeFields: typesFields.inputSelect,
    },
    {
      key: 'comment',
      title: 'Comment',
      typeFields: typesFields.htmlEditor,
    },
    {
      key: 'deadline',
      min: new Date(),
      title: 'Deadline',
      typeFields: typesFields.date,
      isRequired: true,
    },
    {
      key: 'priority',
      title: 'Priority',
      typeFields: typesFields.options,
      options: priorities.map((priority) => prioritiesMap[priority]),
      isRequired: true,
    },
    {
      key: 'contour_complexity_level',
      title: 'Contour complexity level',
      typeFields: typesFields.options,
      options: [ 1, 2, 3, 4 ],
      isRequired: true,
      addedFields: [
        {
          value: '4',
          type: 'number',
          step: '1',
          pattern: /^\d+$/,
          placeholder: 'Укажите число больше 0',
          min: '1',
          key: 'artist_price',
          title: 'Artist Price',
          typeFields: typesFields.input,
          isRequired: true,
        },
      ],
    },
    {
      key: 'color_complexity_level',
      title: 'Color complexity level',
      typeFields: typesFields.options,
      options: [ '1', '2', '3', '4' ],
      isRequired: true,
      addedFields: [
        {
          value: '4',
          type: 'number',
          step: '1',
          pattern: /^\d+$/,
          placeholder: 'Укажите число больше 0',
          min: '1',
          key: 'designer_price',
          title: 'Designer Price',
          typeFields: typesFields.input,
          isRequired: true,
        },
      ],
    },
    {
      key: 'category_id',
      title: 'Category',
      typeFields: typesFields.optionsSearch,
      isRequired: false,
      translate: 'TAGS.CATEGORY',
    },
    {
      key: 'categories',
      title: 'Categories',
      typeFields: typesFields.inputSelect,
      isRequired: false,
      translate: 'TAGS.CATEGORIES',
    },
  ],
  projectSettings: [
    {
      key: 'status',
      title: 'Status',
      typeFields: typesFields.switch,
    },
    {
      key: 'visibility',
      title: 'Visibility',
      typeFields: typesFields.switch,
    },
    {
      translate: 'PROJECT.FIELDS.executor',
      key: taskTypes.artist_drawing.type,
      title: 'Executor',
      typeFields: typesFields.optionsSearch,
      subgroup: 'executors',
    },
    {
      key: 'type',
      title: 'Image category',
      typeFields: typesFields.options,
      options: imageType,
      isRequired: true,
      subgroup: 'options',
    },
  ],
}, {
  key: 'coloring-any',
  title: 'Image for coloring (color)',
  type: globalTypesProject.COLORING,
  generalSettings: [
    {
      key: 'source',
      title: 'Source',
      typeFields: typesFields.options,
      options: [ 'shutterstock', 'any' ],
      isRequired: true,
      subgroup: 'options',
      addedFields: [
        {
          value: 'shutterstock',
          key: 'image_id',
          title: 'Shutterstock ID',
          typeFields: typesFields.input,
          type: 'number',
          step: '1',
          min: '0',
          placeholder: 'Укажите число от 0 и более',
          pattern: /^\d+$/,
          isRequired: true,
        },
        {
          value: 'shutterstock',
          key: 'resourceLink',
          title: 'Resource link',
          typeFields: typesFields.input,
        }, {
          value: 'shutterstock',
          key: 'title',
          title: 'Title',
          typeFields: typesFields.input,
          pattern: /[^а-яА-Я]+/,
          isRequired: true,
          altTitle: 'В названии проекта можно использовать только латиницу',
        },
        {
          value: 'shutterstock',
          key: 'category_id',
          title: 'Category',
          typeFields: typesFields.optionsSearch,
          isRequired: false,
          translate: 'TAGS.CATEGORY',
        },
        {
          value: 'shutterstock',
          key: 'categories',
          title: 'Categories',
          typeFields: typesFields.inputSelect,
          isRequired: false,
          translate: 'TAGS.CATEGORIES',
        },
        {
          value: 'shutterstock',
          key: 'hc_release_date',
          min: new Date(),
          title: 'Release date in Happy Color',
          typeFields: typesFields.date,
        },
        {
          value: 'shutterstock',
          key: 'deadline',
          min: new Date(),
          title: 'Deadline',
          typeFields: typesFields.date,
          isRequired: true,
        },
        {
          value: 'shutterstock',
          key: 'hc_content_type',
          title: 'Content type in Happy Color',
          typeFields: typesFields.options,
          options: hcContentTypes,
        },
        {
          value: 'shutterstock',
          key: 'priority',
          title: 'Priority',
          typeFields: typesFields.options,
          options: priorities.map((priority) => prioritiesMap[priority]),
          isRequired: true,
        },
        {
          value: 'any',
          key: 'resourceLink',
          title: 'Resource link',
          typeFields: typesFields.input,
        }, {
          value: 'any',
          key: 'title',
          title: 'Title',
          typeFields: typesFields.input,
          pattern: /[^а-яА-Я]+/,
          isRequired: true,
          altTitle: 'В названии проекта можно использовать только латиницу',
        },
        {
          value: 'any',
          key: 'description',
          title: 'Description',
          typeFields: typesFields.input,
          isRequired: false,
        },
        {
          value: 'any',
          key: 'category_id',
          title: 'Category',
          typeFields: typesFields.optionsSearch,
          isRequired: false,
          translate: 'TAGS.CATEGORY',
        },
        {
          value: 'any',
          key: 'categories',
          title: 'Categories',
          typeFields: typesFields.inputSelect,
          isRequired: false,
          translate: 'TAGS.CATEGORIES',
        },
        {
          value: 'any',
          key: 'hc_release_date',
          min: new Date(),
          title: 'Release date in Happy Color',
          typeFields: typesFields.date,
        },
        {
          value: 'any',
          key: 'deadline',
          min: new Date(),
          title: 'Deadline',
          typeFields: typesFields.date,
          isRequired: true,
        },
        {
          value: 'any',
          key: 'hc_content_type',
          title: 'Content type in Happy Color',
          typeFields: typesFields.options,
          options: hcContentTypes,
        },
        {
          value: 'any',
          key: 'priority',
          title: 'Priority',
          typeFields: typesFields.options,
          options: priorities.map((priority) => prioritiesMap[priority]),
          isRequired: true,
        } ],
    },
    {
      key: 'difficult',
      title: 'Difficulty',
      typeFields: typesFields.options,
      options: difficultyTypes,
    },
    {
      key: 'tags',
      title: 'Tags',
      typeFields: typesFields.inputSelect,
    },
  ],
  projectSettings: [
    {
      key: 'color_complexity_level',
      title: 'Color complexity level',
      typeFields: typesFields.options,
      options: [ '1', '2', '3', '4' ],
      isRequired: true,
      addedFields: [
        {
          value: '4',
          type: 'number',
          step: '1',
          pattern: /^\d+$/,
          placeholder: 'Укажите число больше 0',
          min: '1',
          key: 'designer_price',
          title: 'Designer Price',
          typeFields: typesFields.input,
          isRequired: true,
        },
      ],
    },
    {
      key: 'type',
      title: 'Image category',
      typeFields: typesFields.options,
      options: imageType,
      isRequired: true,
      subgroup: 'options',
    },
    {
      key: 'status',
      title: 'Status',
      typeFields: typesFields.switch,
    },
    {
      key: 'visibility',
      title: 'Visibility',
      typeFields: typesFields.switch,
    },
    {
      key: 'comment',
      title: 'Comment',
      typeFields: typesFields.htmlEditor,
    },
  ],
},
];

export const projectTypeByKey = {};

projectTypes.forEach((type) => {
  projectTypeByKey[type.key] = type;
});
